export default __webpack_public_path__ + "static/magdalena2-c731125816ed579f5a3e9e9d84593d4e.png";